import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import { RegularButton, SecondaryButton } from "styles/jss/Layout.styles";
import {
  FormInput,
  FormRadioGroup,
  FormSelectInput,
} from "../../../FormControllers";

import * as yup from "yup";

const validationSchema = yup.lazy(value => {
  const shapes = {};
  shapes[`number_of_people`] = yup
    .number()
    .oneOf([1, 2, 3, 4, 5, 6])
    .required("Field is Required");

  const arrayOfInputs = Array.from(
    Array(value?.number_of_people).keys(),
    item => item + 1,
  );

  arrayOfInputs.forEach(item => {
    shapes[`name_offeror_${item}`] = yup.string().required("Field is Required");
    shapes[`type_company_offeror_${item}`] = yup
      .string()
      .oneOf(["خارج از سازمان", "شرکت همکار"])
      .required("Field is Required");

    shapes[`name_partner_company_offeror_${item}`] = yup
      .string()
      .when(`type_company_offeror_${item}`, {
        is: val => val === "شرکت همکار",
        then: yup.string().trim().required("Field is Required"),
      });
    shapes[`personnelId_partner_company_offeror_${item}`] = yup
      .string()
      .when(`type_company_offeror_${item}`, {
        is: val => val === "شرکت همکار",
        then: yup.string().trim().required("Field is Required"),
      });
    shapes[`unit_partner_company_offeror_${item}`] = yup
      .string()
      .when(`type_company_offeror_${item}`, {
        is: val => val === "شرکت همکار",
        then: yup.string().trim().required("Field is Required"),
      });
    shapes[`position_partner_company_offeror_${item}`] = yup
      .string()
      .when(`type_company_offeror_${item}`, {
        is: val => val === "شرکت همکار",
        then: yup.string().trim().required("Field is Required"),
      });
    shapes[`degree_partner_company_offeror_${item}`] = yup
      .string()
      .when(`type_company_offeror_${item}`, {
        is: val => val === "شرکت همکار",
        then: yup.string().trim().required("Field is Required"),
      });
    shapes[`major_partner_company_offeror_${item}`] = yup
      .string()
      .when(`type_company_offeror_${item}`, {
        is: val => val === "شرکت همکار",
        then: yup.string().trim().required("Field is Required"),
      });
    shapes[`telephone_partner_company_offeror_${item}`] = yup
      .string()
      .test("Format", "فرمت شماره تلفن صحیح نمی‌باشد", value => {
        if (!!value) {
          const telephone = new RegExp(`^0\\d{6,10}$`);
          return telephone.test(value);
        }
        return true;
      });
    shapes[`job_offeror_${item}`] = yup
      .string()
      .when(`type_company_offeror_${item}`, {
        is: val => val === "خارج از سازمان",
        then: yup.string().trim().required("Field is Required"),
      });
    shapes[`email_offeror_${item}`] = yup
      .string()
      .email()
      .trim()
      .required("Email Field is Required");
    shapes[`phone_offeror_${item}`] = yup
      .string()
      .matches(
        `^(?:0|98|\\+98|\\+980|0098|098|00980)?(9\\d{9})$`,
        "Phone number is not valid",
      )
      .min(11)
      .max(11)
      .required("Field is Required");
  });
  return yup.object().shape(shapes);
});

export default function Step2({ defaultFormValue, setDataForm, prevStep }) {
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { ...defaultFormValue },
  });

  const { handleSubmit, watch } = methods;
  const number_of_people = watch("number_of_people");

  const onSubmit = data => {
    const offerors = Array.from(Array(number_of_people), (_, i) => {
      if (data[`type_company_offeror_${i + 1}`] === "خارج از سازمان") {
        return {
          __component: "forms.proposal-form-outside-offeror-company",
          name: data[`name_offeror_${i + 1}`],
          type_company: data[`type_company_offeror_${i + 1}`],
          job: data[`job_offeror_${i + 1}`],
          phone: +data[`phone_offeror_${i + 1}`],
          email: data[`email_offeror_${i + 1}`],
        };
      } else {
        return {
          __component: "forms.proposal-form-partner-offeror-company",
          name: data[`name_offeror_${i + 1}`],
          type_company: data[`type_company_offeror_${i + 1}`],
          name_company: data[`name_partner_company_offeror_${i + 1}`],
          personnelId: +data[`personnelId_partner_company_offeror_${i + 1}`],
          unit: data[`unit_partner_company_offeror_${i + 1}`],
          position: data[`position_partner_company_offeror_${i + 1}`],
          degree: data[`degree_partner_company_offeror_${i + 1}`],
          major: data[`major_partner_company_offeror_${i + 1}`],
          telephone: data[`telephone_partner_company_offeror_${i + 1}`],
          email: data[`email_offeror_${i + 1}`],
          phone: +data[`phone_offeror_${i + 1}`],
        };
      }
    });

    const keys = Object.keys(data);
    keys.map(item => item.includes("_offeror") && delete data[item]);
    setDataForm({
      ...data,
      offerors: offerors,
    });
  };

  return (
    <FormProvider {...methods}>
      <Grid container columnSpacing={10}>
        <Grid item xs={12} md={6}>
          <FormSelectInput
            label={"تعداد افراد شرکت کننده در پیشنهاد"}
            name="number_of_people"
            defaultValue={1}
            fullWidth
            required
            options={[
              { label: "1", value: 1 },
              { label: "2", value: 2 },
              { label: "3", value: 3 },
              { label: "4", value: 4 },
              { label: "5", value: 5 },
              { label: "6", value: 6 },
            ]}
          />
        </Grid>
      </Grid>
      {Array.from(Array(number_of_people), (x, i) => i + 1).map(
        (item, index) => (
          <RenderInputs key={+item} item={item} watch={watch} />
        ),
      )}

      <Grid container justifyContent={"flex-end"} sx={{ columnGap: "20px" }}>
        <RegularButton type={"button"} onClick={() => prevStep()}>
          مرحله قبل
        </RegularButton>
        <SecondaryButton
          variant={"contained"}
          type={"submit"}
          onClick={handleSubmit(onSubmit)}
        >
          ثبت پیشنهاد
        </SecondaryButton>
      </Grid>
    </FormProvider>
  );
}

const RenderInputs = ({ item, watch }) => {
  const company = watch(`type_company_offeror_${item}`);

  return (
    <Grid container columnSpacing={10}>
      <Grid item xs={12} md={6}>
        <FormInput
          label={`نام و نام خانوادگی پیشنهاد دهنده ${item}`}
          type="text"
          name={`name_offeror_${item}`}
          fullWidth
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormRadioGroup
          label={`شرکت پیشنهاد دهنده ${item}`}
          name={`type_company_offeror_${item}`}
          options={[
            { label: "خارج از سازمان", value: "خارج از سازمان" },
            { label: "شرکت همکار", value: "شرکت همکار" },
          ]}
          required
        />
      </Grid>
      {!!company && company === "شرکت همکار" && (
        <>
          <Grid item xs={12} md={6}>
            <FormInput
              label={`نام شرکت همکار پیشنهاد دهنده ${item}`}
              type="text"
              name={`name_partner_company_offeror_${item}`}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormInput
              label={`شماره پرسنلی پیشنهاد دهنده ${item}`}
              type="number"
              name={`personnelId_partner_company_offeror_${item}`}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormInput
              label={`واحد پیشنهاد دهنده ${item}`}
              type="text"
              name={`unit_partner_company_offeror_${item}`}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormInput
              label={`سمت فرد پیشنهاد دهنده ${item}`}
              type="text"
              name={`position_partner_company_offeror_${item}`}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormSelectInput
              label={`مدرک تحصیلی پیشنهاد دهنده ${item}`}
              name={`degree_partner_company_offeror_${item}`}
              fullWidth
              required
              options={[
                { label: "دکتری", value: "دکتری" },
                { label: "فوق لیسانس", value: "فوق لیسانس" },
                { label: "لیسانس", value: "لیسانس" },
                { label: "کاردانی", value: "کاردانی" },
                { label: "دیپلم", value: "دیپلم" },
              ]}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormInput
              label={`رشته تحصیلی پیشنهاد دهنده ${item}`}
              type="text"
              name={`major_partner_company_offeror_${item}`}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormInput
              label={`شماره داخلی پیشنهاد دهنده اول ${item}`}
              name={`telephone_partner_company_offeror_${item}`}
              fullWidth
            />
          </Grid>
        </>
      )}

      {!!company && company === "خارج از سازمان" && (
        <Grid item xs={12} md={6}>
          <FormInput
            label={` شغل پیشنهاد دهنده${item}`}
            type="text"
            name={`job_offeror_${item}`}
            fullWidth
            required
          />
        </Grid>
      )}

      <Grid item xs={12} md={6}>
        <FormInput
          label={`شماره همراه پیشنهاد دهنده ${item}`}
          type="number"
          name={`phone_offeror_${item}`}
          fullWidth
          required
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormInput
          label={`پست الکترونیکی پیشنهاد دهنده ${item}`}
          type="email"
          name={`email_offeror_${item}`}
          required
          fullWidth
        />
      </Grid>
    </Grid>
  );
};
